// src/graphql/queries/statsQueries.js

export const getStats = () => `query GetStats {
    stats {
        totalTenders
        newTenders
        relevantTenders
        notLucrativeTenders
        declinedTenders
        submittedTenders
        pendingCrawls
        pendingAssessments
        activeJobs
        lastSyncTime
    }
}`;

export const getSystemHealth = () => `query GetSystemHealth {
    systemHealth {
        name
        status
        responseTimeMs
        lastChecked
        details
    }
}`;

export const getSystemConfig = () => `query GetSystemConfig {
    systemConfig {
        key
        value
    }
}`;
